import React from 'react';
import { Controller } from 'react-hook-form';
import { ClipLoader } from 'react-spinners';
import { ICategory } from '../../../../../../Interfaces/responseTypes';
import useEditCategory from './editCategory-hook';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import { IUpdateCreatedCategoryForm } from '../../../../../../Interfaces/formValue-interfaces';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import FileUploader from '../../../../../../Components/FileUploader/fileUploader';
import AuthInput from '../../../../../../Components/Inputs/AuthInput/authInput';
import AutoComplete from '../../../../../../Components/Inputs/AutoComplete/autoComplete';
import Button from '../../../../../../Components/Button/button';
import { AccordeonArrow } from '../../../../../../Assets/Icons';
import styles from './editCategory.module.scss';

export interface IEditCategoryProps {
    compnay_id: number,
    data: ICategory,
    title: string,
    onClose: () => void,
    cb:()=>void
};

const EditCategoryDialog: React.FC<IEditCategoryProps> = (props) => {
    const { data, title, onClose } = props;
    const { baseURL } = useGeneralHooks();
    const { t, activeLangSrc, activeLanguage, checkableLanguages } = useLanguagesHooks();
    const {
        errors,
        control,
        imageUrl,
        dialogRef,
        validation,
        defaultImage,
        imageLoading,
        updateLoading,
        menuTypeOptions,
        showTranslations,
        register,
        onUpdate,
        handleFileInputChange,
        handleShowTranslations,
    } = useEditCategory(props);

    return (
        <div className={styles.container} ref={dialogRef}>
            <div className={styles.header}>
                <p>{title}</p>
            </div>
            <form className={styles.form}>
                <div className={styles.item}>
                    <div className={styles.uploadContainer}>
                        <div className={styles.label}>
                            <p>{t('My_Business.Update_Category.Image')}</p>
                        </div>
                        <div className={styles.imageBox}>
                            {
                                imageLoading
                                    ?
                                    <ClipLoader color="#aa002b" size={40} />
                                    :
                                    <img
                                        src={imageUrl ?? `${baseURL}${defaultImage}`}
                                        alt={`${imageUrl}.png`}
                                        className={styles.image}
                                    />
                            }
                        </div>
                        <FileUploader
                            id='logo'
                            handleFileInputChange={handleFileInputChange}
                            buttonTitleStyle={styles.buttonTitle}
                            buttonStyle={`${styles.uploadButton}`}
                        />
                    </div>
                </div>
                {
                    data.is_author
                    &&
                    <>
                        <div className={styles.item}>
                            <div className={styles.label}>
                                <img src={activeLangSrc} alt={`${activeLangSrc}.png`} />
                                <p>
                                    {t('My_Business.Create_Category.Title')}
                                </p>
                            </div>
                            <AuthInput
                                register={register}
                                registerName={`name_${activeLanguage}`}
                                labelStyle={styles.inputLabel}
                                error={errors[`name_${activeLanguage}` as keyof IUpdateCreatedCategoryForm]}
                            />
                        </div>
                        <div className={styles.show} onClick={handleShowTranslations}>
                            <p>{t('My_Business.Update_Category.Show')}</p>
                            <img
                                src={AccordeonArrow}
                                alt="icon.svg"
                                className={`${styles.icon} ${showTranslations ? styles.iconRotated : ''}`}
                            />
                        </div>
                        {
                            showTranslations
                            &&
                            <div className={styles.translations}>
                                {checkableLanguages.map((item) => {
                                    return (
                                        <div className={styles.item} key={item.id}>
                                            <div className={styles.label}>
                                                <img src={item.icon} alt={`${item.icon}.png`} />
                                                <p>
                                                    {t('My_Business.Create_Category.Title')}
                                                </p>
                                            </div>
                                            <AuthInput
                                                register={register}
                                                registerName={`name_${item.code}`}
                                                labelStyle={styles.inputLabel}
                                                error={errors[`name_${item.code}` as keyof IUpdateCreatedCategoryForm]}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        <div className={styles.item}>
                            <div className={styles.label}>
                                <p>
                                    {t('My_Business.Update_Category.Type')}
                                </p>
                            </div>
                            <Controller
                                control={control}
                                name='menu_type'
                                rules={{
                                    required: t('Errors.Required'),
                                }}
                                render={({ field: { onChange, name, value } }) => {
                                    return (
                                        <AutoComplete
                                            value={value}
                                            name={name}
                                            onChange={onChange}
                                            id='user_id'
                                            data={menuTypeOptions}
                                            error={errors.menu_type}
                                        />
                                    );
                                }}
                            />
                        </div>
                    </>
                }
                <div className={styles.buttonsRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('Buttons.Close')}
                        type='button'
                        onClick={onClose}
                        buttonStyle={styles.closeButton}
                    />
                    <Button
                        buttonType={validation ? ButtonTypes.Primery : ButtonTypes.Disabled}
                        title={t('Buttons.Save')}
                        type='button'
                        onClick={onUpdate}
                        isLoading={updateLoading}
                        buttonStyle={styles.button}
                    />
                </div>
            </form>

        </div>
    )
}

export default EditCategoryDialog
